<header class="mast-main-head fixed-top">
  <!-- <div class="main-header-offer-section">
    <p><img class="tree-img" src="assets/img/christ-tree.png" alt="">  Seasonal Special: Enjoy a <b>50%</b> Discount on Any Plan. Use coupon code <b>SEASON50</b>  <img class="skate-img" src="assets/img/skate.png" alt=""></p>
  </div> -->

  <!-- <div class="main-header-subscriber-offer-section">
    <span>🎉 Celebratings! <strong>50k+</strong> users & <strong>2K+</strong> happy subscribers.<b routerLink="/happy-subscribers"> What's in? </b> <img class="arrow" src="assets/img/arrow-right.svg" alt=""> <img class="illus-img" src="assets/img/online-cab.png" alt=""> <img class="illus-img" src="assets/img/team-art.svg" alt=""> <img class="illus-img" src="assets/img/yoga.png" alt=""></span></div> -->

    <!-- Navigation -->
    <!-- style="box-shadow: 0px 0px 10px rgba(0,0,0,0.1)" -->
  <nav class="navbar navbar-expand-lg remove-shadow" id="mainNav">

    <div class="container left-header-subscribe">

      <a class="navbar-brand js-scroll-trigger" routerLink="/home"><img src="assets/img/logo.svg"></a>

      <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
      </button>

      <div class="collapse navbar-collapse" id="navbarResponsive">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a class="nav-link marketplace" routerLink="/how-it-works" style="cursor: pointer;">How it works</a>
          </li>
          <li class="nav-item">
            <a class="nav-link marketplace" (click)="openMarketplace()" style="cursor: pointer;">Marketplace</a>
          </li>
          <li class="nav-item">
            <a class="nav-link marketplace" routerLink="/pricing">Pricing</a>
          </li>
          <li class="nav-item dropdown col-1-dropdown">
            <a class="nav-link dropdown-toggle marketplace" data-toggle="dropdown">Plugins</a>
            <div class="dropdown-menu" style="width: 200px;">
              <ul>
                <li>
                  <a style="color: #000" class="nav-link" href="https://www.figma.com/community/plugin/902086023682633830/Crafttor" target="_blank">
                  <img src="assets/img/ic-figma.png" alt=""> <span>Figma</span> </a>
                  <!-- <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="Icons/Navigation/Arrow Down/Black">
                      <g id="Group">
                        <path id="down_arrow" d="M18.5 9.44444L12.3274 15L6 9.57345" stroke="#b2b2b2" stroke-linecap="round" stroke-linejoin="round"/>
                      </g>
                    </g>
                  </svg> -->
                </li>
                <li><a style="color: #000" class="nav-link" href="https://crafttor.com/sketch" target="_blank">
                  <img src="assets/img/ic-sketch.png" alt=""> <span>Sketch</span> </a></li>
                <li><a style="color: #000" class="nav-link" href="https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator" target="_blank">
                  <img src="assets/img/ai.png" alt="" style="width: 20px; height: 20px; margin-left: 4px;"> <span>Illustrator</span> </a></li>
              </ul>
            </div>
          </li>
          <li class="nav-item">
            <a class="nav-link marketplace" href="https://crafttor.com/blogs" target="_blank">Blog</a>
          </li>
          <li class="nav-item login-btn" *ngIf="showGoToApp">
            <a class="nav-link app-btn" (click)="checkWorkspaces()">Go to app</a>
          </li>
           <li class="nav-item signup-btn">
             <a class="nav-link button" data-toggle="modal" (click)="listWorkspace()">Start for free</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>

<section class="toast-section" *ngIf="mobileViewSection">
  <div class="container">
    <div class="row">
      <div class="col-sm-12 toast-area">
        <span>Crafttor Workspace is best experienced on desktop. To proceed, Log in from a desktop browser.</span>
      </div>
    </div>
  </div>
</section>

<!-- Hero Section -->
<section class="hero-section">
	<div class="container">
		<div class="row">
      <div class="col-sm-6">
				<div class="inner-content">
          <h1>Design In Moments</h1>
					<p>Organise, share, collaborate, and stay consistent on creative files with different teams without leaving your workspace.</p>
					<div class="btn-wrapper">
            <a class="gray-btn" (click)="openLetsTalkDialog(letsTalk)">Book Demo</a>
            <a class="button" (click)="listWorkspace()">Start for Free</a>
					</div>
				</div>
			</div>
			<div class="col-sm-6">
				<div class="img-box">
					<img src="assets/img/work-hero.png" alt="workspace illustration">
				</div>
			</div>
		</div>
	</div>
</section>

<!-- Moving Logos  Section -->
<section class="moving-section">
	<div class="sec-title">
		60k+ creative people & teams trust Crafttor
	</div>
	<div class="moving-logo-wrapper">
		<ul>
			<li>
				<img src="assets/img/airtel.svg" alt="">
			</li>
			<li>
				<img src="assets/img/licious.svg" alt="">
			</li>
			<li>
				<img src="assets/img/byju.svg" alt="">
			</li>
			<li>
				<img src="assets/img/wheels.svg" alt="">
			</li>
			<li>
				<img src="assets/img/deloitte.svg" alt="">
			</li>
			<li>
				<img src="assets/img/flip.svg" alt="">
			</li>
			<li>
				<img src="assets/img/innovaccer.svg" alt="">
			</li>
			<li>
				<img src="assets/img/thoughtworks.svg" alt="">
			</li>
			<li>
				<img src="assets/img/yellow.ai.svg" alt="">
			</li>
			<li>
				<img src="assets/img/airtel.svg" alt="">
			</li>
			<li>
				<img src="assets/img/licious.svg" alt="">
			</li>
			<li>
				<img src="assets/img/byju.svg" alt="">
			</li>
			<li>
				<img src="assets/img/wheels.svg" alt="">
			</li>
			<li>
				<img src="assets/img/deloitte.svg" alt="">
			</li>
			<li>
				<img src="assets/img/flip.svg" alt="">
			</li>
			<li>
				<img src="assets/img/innovaccer.svg" alt="">
			</li>
			<li>
				<img src="assets/img/thoughtworks.svg" alt="">
			</li>
			<li>
				<img src="assets/img/yellow.ai.svg" alt="">
			</li>
		</ul>
	</div>
</section>

<section class="features-sections">
  <h3 class="main-title">Features that makes you productive</h3>
  <div class="container">
    <div class="row">
      <div class="col-sm-5 central-txt">
        <h3 class="header-text-left">Tagging your assets</h3>
        <p class="feature-content-left">Tagging is a great practice for classifying and  organizing assets. Tagging feature allows you & your team to easily categorise and organise your digital content with custom tags, simplifying asset management and retrieval. By assigning relevant tags, you make it easier to search, and manage your assets.</p>
        <a routerLink="/features/tagging"><span>Know more
            <svg _ngcontent-tbs-c85="" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path _ngcontent-tbs-c85="" d="M12.1251 19L19 12L12.1251 5" stroke="#2d7cff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path _ngcontent-tbs-c85="" d="M5 12L18.1255 12" stroke="#2d7cff" stroke-width="1.5" stroke-linecap="round"></path></svg>
          </span>
        </a>
      </div>
      <div class="col-sm-1">
      </div>
      <div class="col-sm-6">
        <img class="contact-option-img main-imgs" src="assets/img/tagging.png">
      </div>
    </div>
  </div>
</section>

<section class="features-sections space-above" style="background: none;">
  <div class="container">
    <div class="row">
      <div class="col-sm-6 feature-areas">
        <img class="contact-option-img main-imgs" src="assets/img/version.png">
      </div>
      <div class="col-sm-1">
      </div>
      <div class="col-sm-5 central-txt">
        <h3 class="header-text-right version-txt">Versioning for clear assets</h3>
        <p class="feature-content-right">Versioning is a systematic management and tracking of changes made to digital assets over time. It empowers you to maintain a seamless revision history for your digital content, tracking of changes and the ability to roll back to previous versions when needed. Streamline your creative process and safeguard your work.</p>
        <a routerLink="/features/versioning"><span>Know more
          <svg _ngcontent-tbs-c85="" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path _ngcontent-tbs-c85="" d="M12.1251 19L19 12L12.1251 5" stroke="#2d7cff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path _ngcontent-tbs-c85="" d="M5 12L18.1255 12" stroke="#2d7cff" stroke-width="1.5" stroke-linecap="round"></path></svg>
        </span></a>
      </div>
    </div>
  </div>
</section>

<section class="features-sections space-above" style="background: none;">
  <div class="container">
    <div class="row">
      <div class="col-sm-5 central-txt">
        <h3 class="header-text-left">Collaboration with teams</h3>
        <p class="feature-content-left">Collaboration helps seamless teamwork by enabling real-time collaboration on projects, with shared access to assets, and synchronised updates. A successful collaboration is great match for innovation, and achieving organisational success. Effortlessly work together, boost productivity, and bring your creative projects to life.</p>
        <a routerLink="/features/collaboration"><span>Know more
          <svg _ngcontent-tbs-c85="" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path _ngcontent-tbs-c85="" d="M12.1251 19L19 12L12.1251 5" stroke="#2d7cff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path _ngcontent-tbs-c85="" d="M5 12L18.1255 12" stroke="#2d7cff" stroke-width="1.5" stroke-linecap="round"></path></svg>
        </span></a>
      </div>
      <div class="col-sm-1">
      </div>
      <div class="col-sm-6 feature-areas">
        <img class="contact-option-img main-share-imgs" src="assets/img/collab.png">
      </div>
    </div>
  </div>
</section>

<section class="features-sections space-above" style="background: none;">
  <div class="container">
    <div class="row">
      <div class="col-sm-6 feature-areas">
        <img class="contact-option-img main-share-imgs" src="assets/img/sharing.png">
      </div>
      <div class="col-sm-1">
      </div>
      <div class="col-sm-5 central-txt">
        <h3 class="header-text-right other-feat-txt">Share the way you want</h3>
        <p class="feature-content-right">Sharing serves as an effective way of collaboration, allowing individuals or teams to connect, work, and grow. It helps you have the flexibility to securely and conveniently share your digital assets using various methods and access controls, ensuring your content reaches the right audience, your way.</p>
        <a routerLink="/features/sharing"><span>Know more
          <svg _ngcontent-tbs-c85="" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path _ngcontent-tbs-c85="" d="M12.1251 19L19 12L12.1251 5" stroke="#2d7cff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path _ngcontent-tbs-c85="" d="M5 12L18.1255 12" stroke="#2d7cff" stroke-width="1.5" stroke-linecap="round"></path></svg>
        </span></a>
      </div>
    </div>
  </div>
</section>

<section class="features-sections space-above" style="background: none;">
  <div class="container">
    <div class="row">
      <div class="col-sm-5 central-txt">
        <h3 class="header-text-left other-feat-txt">Integration makes life easy</h3>
        <p class="feature-content-left">Enhance your product performance and interface by
          choosing the right plugin. Integration with plugins like Figma, Sketch, Illustrator, etc. helps you & your team access your organisation's assets from anywhere, & you can also upload the assets from your workspace.</p>
        <a routerLink="/features/integration"><span>Know more
          <svg _ngcontent-tbs-c85="" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path _ngcontent-tbs-c85="" d="M12.1251 19L19 12L12.1251 5" stroke="#2d7cff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path _ngcontent-tbs-c85="" d="M5 12L18.1255 12" stroke="#2d7cff" stroke-width="1.5" stroke-linecap="round"></path></svg>
        </span></a>
      </div>
      <div class="col-sm-1">
      </div>
      <div class="col-sm-6 feature-areas">
        <img class="back-area-img main-imgs" src="assets/img/feat.png">
      </div>
    </div>
  </div>
</section>

<!-- Give more power to your teams  -->
<section class="give-team-section">
	<div class="container">
		<div class="row">
			<div class="col-sm-12">
				<h3>We Are There For You</h3>
				<h2>Give more power to your teams</h2>
			</div>
		</div>
		<div class="row">
			<div class="col-sm-4">
				<a class="inner-box">
					<div class="thumb-in">
						<img src="assets/img/icon-1.svg">
					</div>
					<h4>Increase Productivity</h4>
					<p>Share & use assets from anywhere, which helps you & your team be more efficient & productive.</p>
				</a>
			</div>
			<div class="col-sm-4">
				<a class="inner-box">
					<div class="thumb-in">
						<img src="assets/img/icon-2.svg">
					</div>
					<h4>Increase Collaboration</h4>
					<p>Upload, share, & take feedback on the designs for a better outcome. Which makes the design process fast.</p>
				</a>
			</div>
			<div class="col-sm-4">
				<a class="inner-box">
					<div class="thumb-in">
						<img src="assets/img/icon-3.svg">
					</div>
					<h4>Consistent Design</h4>
					<p>As a professional or brand, it’s important to have good & consistent design. Which makes the product trustworthy for the client & user.</p>
				</a>
			</div>
			<div class="col-sm-4">
				<a class="inner-box">
					<div class="thumb-in">
						<img src="assets/img/icon-4.svg">
					</div>
					<h4>Organise Fast & Easy</h4>
					<p>Organise your assets hassle-free and in a manner you want, which makes them accessible at your fingertips.</p>
				</a>
			</div>
			<div class="col-sm-4">
				<a class="inner-box">
					<div class="thumb-in">
						<img src="assets/img/icon-5.svg">
					</div>
					<h4>Access Asset from Anywhere</h4>
					<p>Access and use your creative assets with in your workspace without leaving your workspace.</p>
				</a>
			</div>
			<div class="col-sm-4">
				<a class="inner-box">
					<div class="thumb-in">
						<img src="assets/img/icon-6.svg">
					</div>
					<h4>Store & sync</h4>
					<p>Keep all your files or assets securely stored, up to date, and accessible from any workspace through our pugins.</p>
				</a>
			</div>
		</div>
	</div>
  </section>

  <!-- Impact drawn by Crafttor Section -->
<section class="impact-drawn-section">
	<div class="container">
		<div class="row">
			<div class="col-sm-12">
				<h4>How Are Helpful?</h4>
				<h2>Impact drawn by Crafttor</h2>
			</div>
		</div>
		<div class="inner-impact">
			<div class="row">
				<div class="col-md-3">
					<div class="inner">
						<h2>8X</h2>
						<h4>Increase <br>Team Collaboration</h4>
					</div>
				</div>
				<div class="col-md-3">
					<div class="inner">
						<h2>80%</h2>
						<h4>Increase <br>in productivity</h4>
					</div>
				</div>
				<div class="col-md-3">
					<div class="inner">
						<h2>50%</h2>
						<h4>Reduce design <br>assets expenses</h4>
					</div>
				</div>
				<div class="col-md-3">
					<div class="inner">
						<h2>90%</h2>
						<h4>Design <br>Consistency</h4>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

  <!-- Plugin Section -->
<section class="plugin-section">
	<div class="container">
		<div class="row">
			<div class="col-md-7">
			<h2>Enjoy Crafttor plugins for your preferred workspace</h2>
			</div>
			<div class="col-md-5">
				<div class="img-wrap">
					<img src="assets/img/plugin-img.svg">
				</div>
			</div>
		</div>
	</div>
</section>

<section class="plugins-box-section">
  <div class="container row text-right">
    <div class="col-md-7 col-sm-12 plugin-apps">
        <a href="https://www.figma.com/community/plugin/902086023682633830/crafttor" target="_blank">
          <div class="plugins-app"><img src="assets/img/crafttor.png">
          <div class="label">Workspace</div></div>
        </a>
        <a href="https://crafttor.com/sketch" target="_blank">
          <div class="plugins-app"><img src="assets/img/sketch.svg">
          <div class="label">Sketch</div></div>
        </a>
        <a href="https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator" target="_blank">
          <div class="plugins-app"><img src="assets/img/xd.png">
          <div class="label">Illustrator</div></div>
        </a>
        <a href="https://www.figma.com/community/plugin/1408354139656199596/kaleidoscope" target="_blank">
          <div class="plugins-app"><img src="assets/img/kalei.png">
          <div class="label">Kaleidoscope</div></div>
        </a>
        <a href="https://www.figma.com/community/plugin/1406167507218530657/iso-all" target="_blank">
          <div class="plugins-app"><img src="assets/img/iso.png">
          <div class="label">Iso All</div></div>
        </a>
        <a href="https://www.figma.com/community/plugin/1409844094149025473/translate-ai" target="_blank">
          <div class="plugins-app"><img src="assets/img/trans.png">
          <div class="label">Translate AI</div></div>
        </a>
        <a href="https://www.figma.com/community/plugin/1417763374654877658/image-to-figma-design-beta" target="_blank">
          <div class="plugins-app"><img src="assets/img/img-fig.png">
          <div class="label">Image to Figma</div></div>
        </a>
        <a href="https://www.figma.com/community/plugin/1409553168281102402/bannners" target="_blank">
          <div class="plugins-app"><img src="assets/img/bannner.png">
          <div class="label">Bannners</div></div>
        </a>
    </div>
  </div>
</section>

<!-- Big CTA Section -->
<section class="cta-section">
	<div class="container">
		<div class="inner-cta">
			<div class="row">
				<div class="col-md-7">
					<h2>Make your team more productive with Crafttor</h2>
				</div>
				<div class="col-md-5">
					<div class="btn-wrap">
						<a class="button" (click)="openLetsTalkDialog(letsTalk)">Book Demo</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>

  <div
  	style="width: 100%;
  	background-color: rgba(0,0,0, .9);
    padding-top:200px;"
    class="modal"
    tabindex="-1"
    role="dialog"
    [ngStyle]="{'display':maintenanceProcessStyle}">
  	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="height: 100px;
      width: 35%; margin: 0 auto; text-align: center;">
  		<div class="modal-content" style="padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
        <button style="text-align: end;" type="button" class="close" (click)="closeNewUserStyle()" data-dismiss="modal" aria-label="Close">
  				<img src="assets/img/cross.svg" alt="download free illustrations">
  			</button>
  			<div class="modal-body">
  				<img class="main-loader-img" src="assets/img/maintain.png" style="width: 180px" alt="">
  			  <h6>Our website is going through a maintenance and will be available soon.
            <br>We request you to visit after sometime.</h6>
  			  <p>Thank you! for visiting.</p>
  			</div>
  		</div>
  	</div>
  </div>

  <!-- Footer -->
  <footer class="site-footer">
    <div class="container">
    <div class="row">
      <div class="col-sm-3">
        <div class="coulmn-1">
  				<img src="assets/img/logo.svg">
  				<p>Digital assets management</p>
  				<a href="mailto:info@crafttor.com"><i class="fa fa-envelope" aria-hidden="true"></i> info@crafttor.com</a>
  			</div>
      </div>
      <!-- 3 -->
      <div class="col-sm-2">
        <h5>Products</h5>
        <ul class="menu">
          <li><a>Workspace</a></li>
          <li><a (click)="openMarketplace()">Marketplace</a></li>
          <li><a routerLink="/features">Features</a></li>
          <li><a routerLink="/mobile-apps">Crafttor for Mobile</a></li>
          <li><a routerLink="/smart-storage">Smart storage</a></li>
          <li><a routerLink="/effective-search">Effective search</a></li>
        </ul>
      </div>

      <div class="col-sm-2">
        <h5>Plugins</h5>
        <ul class="menu">
          <li><a href="https://www.figma.com/community/plugin/902086023682633830/Crafttor" target="_blank">Figma</a></li>
          <li><a href="https://crafttor.com/sketch" target="_blank">Sketch</a></li>
          <li><a href="https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator" target="_blank">Illustrator</a></li>
          <li><a href="https://www.figma.com/community/plugin/1408354139656199596/kaleidoscope" target="_blank">Kaleidoscope</a></li>
          <li><a href="https://www.figma.com/community/plugin/1406167507218530657/iso-all" target="_blank">Iso All</a></li>
          <li><a href="https://www.figma.com/community/plugin/1409844094149025473/translate-ai" target="_blank">Translate AI</a></li>
          <li><a href="https://www.figma.com/community/plugin/1417763374654877658/image-to-figma-design-beta" target="_blank">Image to Figma</a></li>
          <li><a href="https://www.figma.com/community/plugin/1409553168281102402/bannners" target="_blank">Bannners</a></li>
        </ul>
      </div>

      <div class="col-sm-2">
        <h5>Solutions</h5>
        <ul class="menu">
          <li><a routerLink="/dropbox-alternative">Dropbox alternative</a></li>
          <li><a routerLink="/google-drive-alternative">G Drive alternative</a></li>
          <li><a routerLink="/box-alternative">Box alternative</a></li>
          <li><a routerLink="/content-library">Content library</a></li>
          <li><a routerLink="/user-profiling">User Profiling</a></li>
          <li><a routerLink="/approvals">Creative approvals</a></li>
        </ul>
      </div>

      <div class="col-sm-2">
        <h5>Features</h5>
        <ul class="menu">
          <li><a routerLink="/features/tagging">Tagging</a></li>
          <li><a routerLink="/features/sharing">Sharing</a></li>
          <li><a routerLink="/features/versioning">Versioning</a></li>
          <li><a routerLink="/features/collaboration">Collaboration</a></li>
          <li><a routerLink="/features/integration">Integration</a></li>
        </ul>
      </div>

      <div class="col-sm-2">
        <h5>Company</h5>
        <ul class="menu">
          <li><a routerLink="/about-workspace">About Workspace</a></li>
          <li><a routerLink="/contact">Contact Us</a></li>
          <li><a routerLink="/terms">Terms & Conditions</a></li>
          <li><a routerLink="/faq">FAQ</a></li>
          <li><a routerLink="/feedbacks">Feedback</a></li>
          <li><a href="https://crafttor.com/blogs" target="_blank">Blog</a></li>
          <li><a routerLink="/our-mission">Our mission</a></li>
          <li><a routerLink="/partner-with-us">Partner with us</a></li>
        </ul>
      </div>

      <div class="col-sm-3 all-social-icons">
        <h5>Socials</h5>
  				<ul class="social-icons">
  					<li><a rel="nofollow" href="https://www.facebook.com/Crafttor-Studio-102023868185724/?modal=admin_todo_tour" target=”_blank”
              alt="facebook"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
  					<li><a rel="nofollow" href="https://twitter.com/CrafttorS" target=”_blank” alt="twitter"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
  					<li><a rel="nofollow" href="https://www.linkedin.com/company/crafttor/" target=”_blank” alt="linkedin"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
  					<li><a rel="nofollow" href="https://www.instagram.com/crafttorstudio/" target=”_blank” alt="instagram"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
  					<li><a rel="nofollow" href="https://www.youtube.com/channel/UC6SM1D8MU7uwLVEC8uFDW-w/?guided_help_flow=5" target=”_blank” alt="youtube"><i class="fa fa-youtube-play" aria-hidden="true"></i></a></li>
  					<li><a rel="nofollow" href="https://dribbble.com/crafttorstudio" target=”_blank” alt="dribbble"><i class="fa fa-dribbble" aria-hidden="true"></i></a></li>
  					<li><a rel="nofollow" href="https://www.behance.net/crafttorstudio" target=”_blank” alt="behance"><i class="fa fa-behance" aria-hidden="true"></i></a></li>
  				</ul>
      </div>

      <div class="col-sm-12 text-center">
  				<small>&copy; 2025 Crafttor. All rights reserved</small>
  			</div>
    </div>
    </div>
  </footer>

  <ng-template #letsTalk let-letsTalk>
      <div class="custom-dialog custom-dialog-centered sign-up" role="document">
        <div class="modal-content">
          <div class="modal-body">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <img src="assets/img/cross.svg" (click)="letsTalk.close()">
            </button>
          <div class="modal-body">
        <h2>Let's talk!</h2>
        <p>Schedule a free demo today. We will show you a demo of how Crafttor Workspace works.</p>
        <div class="form-wrapper">
          <form class="row g-3" [formGroup]="letsTalkForm" (ngSubmit)="submitContactUs(selectDate)">
            <div class="col-md-6">
            <label class="form-label">First Name<span>*</span></label>
            <input id="textinput" formControlName="name" type="text" placeholder="Brian" class="form-control input-md" required>
            <span class="text-danger error-text"
            *ngIf="(letsTalkForm.controls.name.touched || submitted) && letsTalkForm.controls.name.errors?.required">
            First Name is required
          </span>
            </div>
            <div class="col-md-6">
            <label class="form-label">Last Name<span>*</span></label>
            <input id="textinput" formControlName="lname" type="text" placeholder="Storm" class="form-control input-md" required>
            <span class="text-danger error-text"
            *ngIf="(letsTalkForm.controls.lname.touched || submitted) && letsTalkForm.controls.lname.errors?.required">
            Last Name is required
          </span>
            </div>
            <div class="col-12">
            <label for="businessEmail" class="form-label">Business Email<span>*</span></label>
            <input id="textinput" formControlName="email" type="email" placeholder="abc@crafttor.com" class="form-control input-md" >
            <span class="text-danger error-text"
            *ngIf="(letsTalkForm.controls.email.touched || submitted) && letsTalkForm.controls.email.errors?.required">
            Email is required
          </span>
          <span class="text-danger error-text"
          *ngIf="(letsTalkForm.controls.email.touched || submitted) && letsTalkForm.controls.email.errors?.pattern">
          Email is not valid
        </span>
            </div>
            <div class="col-12">
            <label for="company" class="form-label">Company<span>*</span></label>
            <input id="textinput" formControlName="company" type="text" placeholder="Crafttor" class="form-control input-md" >
  					<span class="text-danger error-text"
            *ngIf="(letsTalkForm.controls.company.touched || submitted) && letsTalkForm.controls.company.errors?.required">
            Company Name is required
          </span>
            </div>

            <div class="col-md-12" style="display: none;">
              <label class="form-label" for="textarea">Message</label>
              <input id="textinput" formControlName="message" type="text" class="form-control input-md" required>
              <span class="text-danger error-text"
              *ngIf="(letsTalkForm.controls.message.touched || submitted) && letsTalkForm.controls.message.errors?.required">
              Message is required
            </span>
            </div>


            <div class="col-12">
            <button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="!showLeaveLoader">Submit</button>
  					<button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="showLeaveLoader"><img src="assets/img/img-up-white.svg" alt="" style="height: 18px;"></button>
            </div>
          </form>
        </div>
        <p>By Submiting the form, You agree to our <a routerLink="/terms" target="_blank">Terms of Service</a> and acknowledge our <a routerLink="/terms" target="_blank">Privacy Policy</a>.</p>
          </div>
        </div>
      </div>
      </div>
  </ng-template>


  <ng-template #selectDate let-selectDate>
      <div class="custom-dialog custom-dialog-centered select-time-popup" role="document">
        <div class="modal-content">
          <div class="modal-body">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <img src="assets/img/cross.svg" (click)="selectDate.close()">
            </button>
          <div class="modal-body">
        <h6>{{thankYouText}}</h6>
        <h6>(IST)</h6>
        <div class="form-wrapper">
  				<ul class="date-listing" *ngFor="let slots of availableSlots | slice:1:5; let i = index">
  					<li *ngIf="showDate">
  						<div class="date-list" (click)="selectDateSales(slots.date, slots.day, slots.month)">
  							<!-- <div class="date-list-day" style="background: #f9f9f9">
  								<a href="javascript:;">{{slots.day}}</a>
  							</div> -->
  							<div class="">
  								<a href="javascript:;">{{slots.month}} {{slots.date1}}</a>
  							</div>
  							<!-- <a href="javascript:;">{{slots.month}}</a> -->
  						</div>
  					</li>
  				</ul>

  				<div *ngIf="!showDate" class="selected-date">
  					<div class="date-list-days">
  						<a href="javascript:;">{{shownDay}}</a>
  					</div>
  					<div style="padding-top:10px;" class="">
  						<a href="javascript:;">{{shownDate}}</a>
  					</div>
  					<!-- <a href="javascript:;">{{shownMonth}}</a> -->
  				</div>

  				<p *ngIf="!showDate" (click)="changeDate()" class="change-date-txt">Change Date</p>

  				<h6 style="margin-top:20px;" *ngIf="showTime">What time works?</h6>

  				<ul *ngFor="let time of availableTimeSlots; let i = index">
  					<li *ngIf="showTime">
  						<div class="time-list" (click)="selectTimeSales(time)">
  							<div style="text-align: center;" class="">
  								<a href="javascript:;">{{time}}</a>
  							</div>
  						</div>
  					</li>
  				</ul>
  				<div *ngIf="showFinalTime" style="text-align: center;" class="selected-time">
  					<a href="javascript:;">{{shownTime}}</a>
  				</div>
  				<p *ngIf="!showTime" (click)="changeTime()" class="change-time-txt"></p>
  				<button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="!timeSelected && !dateSelected && showSubmitBtn" (click)="contactSalesCall(thankyou)">Submit</button>
  				<button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="!timeSelected && dateSelected && showSubmitBtn" (click)="contactSalesCall(thankyou)">Submit</button>
  				<button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="timeSelected && !dateSelected && showSubmitBtn" (click)="contactSalesCall(thankyou)">Submit</button>
  				<button id="singlebutton" name="singlebutton button" class="btn btn-primary" (click)="contactSalesCall(thankyou); selectDate.close()" *ngIf="timeSelected && dateSelected && showSubmitBtn">Submit</button>
  				<p *ngIf="showSelectionMessage" class="text-danger error-text" style="text-align: center; margin-top:10px; font-weight: 600">{{showSelectedMsg}}</p>
        </div>
        <p>By Submiting the form, You agree to our <a routerLink="/terms" target="_blank">Terms of Service</a> and acknowledge our <a routerLink="/terms" target="_blank">Privacy Policy</a>.</p>
          </div>
        </div>
      </div>
      </div>
  </ng-template>

<ng-template #showloader let-showloader>
    <div class="custom-dialog custom-dialog-centered show-loader" role="document">
      <div class="modal-content">
      	<div class="modal-body">
  				<img class="main-loader-img" style="margin-top: 200px; width: 180px;" src="assets/img/loader.svg" alt="">
  			  <h6 style="font-size: 16px;">Please wait</h6>
  			  <p>Confirming your meeting time..</p>
  			</div>
  	</div>
  </div>
</ng-template>


  <ng-template #thankyou let-thankyou>
    <div class="custom-dialog custom-dialog-centered thanks-popup" role="document">
      <div class="modal-content">
        <div class="modal-body">
      		<h5>Thank you <br>Your meeting is confirmed. </h5>
      			<div class="conver-grid">
        			<div class="img-wrapper">
          			<img src="" >
          			<img src="assets/img/tick.png" class="tick">
        			</div>
        		<p>You are meeting with</p>
        		<h4>Sandeep Virk</h4>
      			</div>
      	<div class="invitation-wrapper">
        	<div class="">You will receive a meeting invitation shortly</div>
        		<table>
          	<tbody>
            	<tr>
              	<th>Event</th>
              	<td>Crafttor intro with Sandeep</td>
            	</tr>
            	<!-- <tr>
              	<th>Time</th>
              	<td>Friday, Oct 22nd, 08:30PM - 9:00PM IST</td>
            	</tr> -->
            	<tr>
              	<th>Guest</th>
              	<td>{{userName}}<span><a>{{userEmail}}</a></span></td>
            	</tr>
          	</tbody>
        	</table>
      	</div>
  			<button id="singlebutton" name="singlebutton button" class="btn btn-primary" style="width: 100%;
      margin-top: 20px;" (click)="closeThankDialog()">Close</button>
    	</div>
  	</div>
  </div>
</ng-template>

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
  padding-top:200px;"
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{'display':sendingProcessStyle}">
	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="height: 100px;
    width: 35%; margin: 0 auto; text-align: center;">
		<div class="modal-content" style="padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
			<div class="modal-body loader-messages">
				<img class="main-loader-img" style="width: 140px;" src="assets/img/loader.svg" alt="">
			  <h6 style="font-size: 16px;">Please wait</h6>
			  <p>Confirming your meeting time..</p>
			</div>
		</div>
	</div>
</div>
